import api from "../services/api";

const path = "produto";

export const getProducts = async () => {
  return await api.get(`${path}`);
};

export const findProduct = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editProduct = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createProduct = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteProduct = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
